import { ContributionType, FamilyStatus, Gender, PaymentType } from "@services/member/member/member.types";
import { ApartmentType } from "@services/member/apartment/apartment.types";
import { BookingStatus } from "@services/member/booking/booking.types";
import { Category } from "@services/product/product/product.types";
import { FilterComparator } from "./filters";
import { OrderStatus, PaymentMethod } from "@services/product/order/order.types";
import { UserRole } from "@services/core/auth/auth.types";

export const FAMILY_STATUS: Record<FamilyStatus, string> = {
    'single': 'Célibataire',
    'married': 'Marié',
    'cohabiting': 'En couple',
    'divorced': 'Divorcé',
    'widowed': 'Veuf',
    'separated': 'Séparé',
    'pacs': 'Pacsé',
    'unknown': 'Inconnue'
};

export const GENDER: Record<Gender, string> = {
    'male': 'Masculin',
    'female': 'Féminin',
    'other': 'Autre'
};

export const ROLE: Record<UserRole, string> = {
    'admin': 'Administrateur',
    'user': 'Utilisateur'
}

export const CONTRIBUTION_TYPE: Record<ContributionType, string> = {
    'retired': '3 - Retraité',
    'holder': '1 - Titulaire',
    'assimilated': '2 - Assimilé',
    'not_member': '0 - Non membre',
    'vacataire': '4 - Vacataires'
};


export const CONTRIBUTION_PRICE: Record<ContributionType, number> = {
    'not_member': 0,
    'retired': 10,
    'holder': 17,
    'assimilated': 8,
    'vacataire': 8
};

export const PAYMENT_TYPE: Record<PaymentType, string> = {
    'pending': 'En attente',
    'cash': 'Espèces',
    'check': 'Chèque',
    'cb': 'Carte bancaire',
    'direct_debit': 'Prélèvement',
};
export const CATEGORY_TYPE: Record<Category, string> = {
    'sorties_voyages': 'Sorties & voyages',
    'spectacles': 'Spectacles',
    'e-billets': 'E-billets',
    'offres_partenaires': 'Offres partenaires',
    'loisirs': 'Loisirs',
    'services': 'Services',
    'cooperative_cosem': 'Coopérative Cosem'
};

export const APARTMENT_TYPE: Record<ApartmentType, string> = {
    'studio': 'Studio',
    'apartment': 'Appartement'
};


export const FILTER_COMPARATOR: Record<FilterComparator, string> = {
    'isBefore': 'Avant',
    'isAfter': 'Après',
    'isBetween': 'Entre',
    'contains': 'Contient',
    'includes': 'Contient',
    'equals': 'Égal à',
    'startsWith': 'Commence par',
    'endsWith': 'Finit par',
}

export const ORDER_STATUS: Record<OrderStatus, string> = {
    'completed': 'Terminée',
    'pending': 'Attente paiement',
    'processing': 'En cours',
    'on-hold': 'En attente',
    'cancelled': 'Annulée',
    'refunded': 'Remboursée',
    'failed': 'Échouée'
};


export const PAYMENT_METHOD: Record<PaymentMethod, string> = {
    'bacs': 'Virement bancaire'
};

export const BOOKING_STATUS: Record<BookingStatus, string> = {
    upcoming: 'À venir',
    current: 'En cours',
    past: 'Passées',
    all: 'Toutes'
};
